module.exports = __webpack_public_path__ + "static/media/bars-solid.d3479a93.svg";